import { useLazyUserLogin } from '@gef-ui/authorization-v2';
import { getHelpdeskErrorObject } from '@gef-ui/error-report-core/utils';
import { sentFailed, sentSuccessfully } from '../../actions';
import { useErrorDispatch } from '../../context';
import useSendErrorBase from '../useSendErrorBase';
const useSendErrorContext = (sendErrorCallback)=>{
    const dispatch = useErrorDispatch();
    const sendErrorBase = useSendErrorBase(sendErrorCallback);
    const getUser = useLazyUserLogin();
    return async (fe, be, error, timestamp)=>{
        const handleCaughtError = ()=>dispatch(sentFailed(error));
        const body = getHelpdeskErrorObject(fe, be, error, getUser(), timestamp);
        try {
            const response = await sendErrorBase(body);
            if (response.ok) {
                dispatch(sentSuccessfully(error));
            } else {
                handleCaughtError();
            }
        } catch (_e) {
            handleCaughtError();
        }
    };
};
export default useSendErrorContext;
